/**
 * 菜单类型
 */
export enum MENU_TYPE {
  // 外链
  LINK = 'PUifc+82PPxOWO/yDM42RA==',
  // 操作
  ACTION = 'RWzBGeCJV52QVOjQLYVIpw==',
  // 菜单
  MENU = 'ePntJyyvxDfD/8SNlYLOow==',
  // 模块
  MODULE = 'TICceZKFSRPRVNYLkycsGA=='
}

export const SIDE_VISIBLE_MENU_TYPES: string[] = [MENU_TYPE.MENU, MENU_TYPE.LINK]
